import Axios from 'axios'
import * as React from 'react'
import {connect} from 'react-redux'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {getDateString} from '../../core/helpers'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {config} from '../../core/reducers/config'
import {IAppStore} from '../../interfaces/reducers'
import appConfig from '../../reducers/appConfig'
import {ILayerNames, StreetImportParameterSelector} from './StreetImportParameterSelector'
interface Props {
  infos: IFeatureLayerInfos
}
interface IStrPlan {
  Id: number
  PlanDate: string
  PlanName: string
}
interface ICheckResults {
  id: string
  segmentsDxf: string
  polygonsDxf: string
  foundPolygons: number
  foundOsLines: number
  foundTrotoLines: number
  foundPoints: number
  prevPlans: IStrPlan[]
  nextPlans: IStrPlan[]
}
interface State {
  loading: boolean
  afterSuccess: boolean
  afterCheck: boolean
  errors: string[]
  segmentsDxfOnErrors: string
  layerNames: ILayerNames
  checkResults?: ICheckResults
}

export class UnregulatedImportClass extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      afterCheck: false,
      errors: [],
      segmentsDxfOnErrors: '',
      layerNames: {
        DataCS: CoordinateSystem.BG_705,
        PlanName: '',
        Expanded: false,
        PlanDate: new Date(),
        Cp1251: false,

        KvLayer: 'RP_REG',
        StrPolygonEnd: 'RP_REG_KR',

        OSLineLayer: 'RP_OS',

        TrotoLayer: 'RP_REGT',

        OTBlockName: 'OT_N',
        OTNomerTag: 'NOMER',
        OTKotaTag: 'KOTA',
        OTCreatedTag: 'CREATOR',
        OTDescTag: 'DESCRIPTION'
      }
    }
  }

  setErrorState = (error: any) => {
    const state = {...this.state, loading: false}
    if (error.response && error.response.data && error.response.data) {
      if (error.response.data.Errors) {
        state.errors = error.response.data.Errors
      } else {
        state.errors = [error.response.data]
      }
      if (error.response.data.SegmentsDxf) {
        state.segmentsDxfOnErrors = error.response.data.SegmentsDxf
      }
    } else {
      state.errors = ['Възникна грешка ' + error.message]
    }
    this.setState(state)
  }

  importBtn = () => {
    if (!this.state.checkResults) {
      return null
    }
    return (
      <button
        type="button"
        className="button width"
        onClick={() => {
          this.setState({...this.state, loading: true, afterSuccess: false, segmentsDxfOnErrors: ''}, () => {
            Axios.get(config.getConfig().urls.importStreetRegUrl + this.state.checkResults!.id)
              .then(r => {
                this.setState({...this.state, errors: [], loading: false, checkResults: undefined, afterSuccess: true})
                this.props.infos[appConfig.streetreg.area.url].refresh()
                this.props.infos[appConfig.streetreg.arealines.url].refresh()
                this.props.infos[appConfig.streetreg.os.url].refresh()
                this.props.infos[appConfig.streetreg.troto.url].refresh()
                this.props.infos[appConfig.streetreg.points.url].refresh()
              })
              .catch(this.setErrorState)
          })
        }}
      >
        Импорт
      </button>
    )
  }
  checkBtn = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={
          !this.state.layerNames.file ||
          !this.state.layerNames.location ||
          !this.state.layerNames.PlanDate ||
          !this.state.layerNames.PlanName
        }
        onClick={() => {
          const formData = new FormData()
          formData.append('File', this.state.layerNames.file!.file!, this.state.layerNames.file!.name)
          const payload: {[key: string]: any} = {
            LocationId: this.state.layerNames.location!.getProperties()['Id'],
            PlanDate: this.state.layerNames.PlanDate.toISOString()
          }
          for (const key in this.state.layerNames) {
            if (typeof (this.state.layerNames as any)[key] != 'object') {
              payload[key] = (this.state.layerNames as any)[key]
            }
          }
          formData.append('RegImportInputData', JSON.stringify(payload))
          this.setState({...this.state, loading: true, checkResults: undefined, segmentsDxfOnErrors: ''}, () => {
            Axios.post(config.getConfig().urls.streetImportCheckUrl, formData, {
              headers: {'Content-Type': `multipart/form-data;`}
            })
              .then(r => {
                this.setState({...this.state, errors: [], loading: false, checkResults: r.data})
              })
              .catch(this.setErrorState)
          })
        }}
      >
        Проверка на данните
      </button>
    )
  }
  afterSuccess() {
    return (
      <div>
        <div className="success-div">Успешен импорт</div>
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({
              ...this.state,
              afterSuccess: false,
              afterCheck: false,
              layerNames: {...this.state.layerNames, file: undefined}
            })
          }}
        >
          Нов импорт
        </button>
      </div>
    )
  }

  onerror() {
    if (this.state.errors.length > 0) {
      return (
        <div className="error-div">
          {this.state.errors.map((e, i) => (
            <div style={{minHeight: '10px'}} key={i}>
              {e}
            </div>
          ))}
          <br></br>
          <div>
            <a target="_blank" href={appConfig.urls.xyApiUrl + this.state.segmentsDxfOnErrors} rel="noreferrer">
              Използвани сегменти при търсене на полигоните
            </a>
          </div>
        </div>
      )
    }
    return null
  }

  getCheckResults() {
    const st: React.CSSProperties = {
      padding: '4px'
    }
    if (this.state.checkResults) {
      return (
        <div>
          <br></br>
          <div style={st}>
            <b>Импорт номер: {this.state.checkResults.id}</b>
          </div>
          <br></br>
          <div style={st}>
            Намерени полигони: <b>{this.state.checkResults.foundPolygons}</b>
          </div>
          <div style={st}>
            Намерени осови линии: <b>{this.state.checkResults.foundOsLines}</b>
          </div>
          <div style={st}>
            Намерени осови точки: <b>{this.state.checkResults.foundPoints}</b>
          </div>
          <div style={st}>
            Намерени бордюрни линии: <b>{this.state.checkResults.foundTrotoLines}</b>
          </div>
          <br></br>
          {this.state.checkResults.prevPlans.length == 0 ? null : (
            <div style={{textAlign: 'start'}}>
              <div>
                <b>Предишни планове:</b>
              </div>
              {this.state.checkResults.prevPlans.map((e, i) => (
                <div key={i}>
                  {e.PlanName} от {getDateString(new Date(e.PlanDate))}
                </div>
              ))}
            </div>
          )}
          <br></br>
          <div>
            <b>
              {this.state.checkResults.nextPlans.length == 0
                ? 'Импортираният план ще бъде и актуалния'
                : 'Импортираният план е със стара дата и няма да бъде визуализиран'}
            </b>
          </div>
          <br></br>
          {this.state.checkResults.nextPlans.length == 0 ? null : (
            <div className="warning-div" style={{textAlign: 'start'}}>
              <div>
                <b>Следващи планове:</b>
              </div>
              {this.state.checkResults.nextPlans.map((e, i) => (
                <div key={i}>
                  {e.PlanName} от {getDateString(new Date(e.PlanDate))}
                </div>
              ))}
            </div>
          )}
          <br></br>
          <div style={st}>
            <a target="_blank" href={appConfig.urls.xyApiUrl + this.state.checkResults.segmentsDxf} rel="noreferrer">
              Използвани сегменти при търсене на полигоните
            </a>
          </div>
          <div style={st}>
            <a target="_blank" href={appConfig.urls.xyApiUrl + this.state.checkResults.polygonsDxf} rel="noreferrer">
              Резултат
            </a>
          </div>
          <br></br>
        </div>
      )
    }
  }

  container() {
    if (this.state.afterSuccess) {
      return this.afterSuccess()
    }

    return (
      <div style={{position: 'relative'}}>
        <OverlayLoader show={this.state.loading}></OverlayLoader>
        <StreetImportParameterSelector
          {...this.state.layerNames}
          onChange={p => this.setState({...this.state, layerNames: {...p}})}
        />
        {this.checkBtn()}
        {this.getCheckResults()}
        {this.importBtn()}
        {this.onerror()}
      </div>
    )
  }

  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '100%', overflow: 'auto'} as React.CSSProperties}>
        {this.container()}
      </div>
    )
  }
}

const mapStateToProps = (store: IAppStore) => ({
  infos: store.layerInfos.featureLayerInfos
})

export const UnregulatedImport = connect(mapStateToProps)(UnregulatedImportClass)
